import { SupportedLanguage } from "./SupportedLanguage";

export async function getTranslations(locale: SupportedLanguage) {
  switch (locale) {
    case SupportedLanguage.EN: {
      const imported = await import(
        "~/features/translations/compiled-lang/compiled-en.json"
      );
      return imported.default;
    }

    case SupportedLanguage.HR: {
      const imported = await import(
        "~/features/translations/compiled-lang/compiled-hr.json"
      );
      return imported.default;
    }

    default: {
      const imported = await import(
        "~/features/translations/compiled-lang/compiled-en.json"
      );
      return imported.default;
    }
  }
}
